import typeMap from '../Data/typeMap'
import {NAME_SEPARATOR} from '../Data/consts'
import {loc} from './fileOps'

export const DROPDIR = 'MetaStoryFiles'

export const genEntityName =
  (_name, _id) => `${_name}${NAME_SEPARATOR}${_id}`

export const genDirname = (type, _name, _id, target) => {
  if( !target )
    return loc(`${type}/${genEntityName(_name, _id)}`)
  else
    return `/${target}/${type}/${genEntityName(_name, _id)}`
}

export const genVersionDir =
  (type, _name, _id, target) => `${genDirname(type, _name, _id, target)}/versions`


export const genFname =
  (type, _name, _id) => `${genEntityName(_name, _id)}.${typeMap[type].getExt()}`

export const genVersion =
  (type, _name, _id, _version, initial, target) => {
    let ext = 'vzn'
    if( initial ){
      ext = 'vzn.bak'
    }
    return `${genVersionDir(type, _name, _id, target)}/${_version}${NAME_SEPARATOR}${genFname(type, _id, _name)}.${ext}`
  }

export const genFullFilename =
  (type, _name, _id, target) => `${genDirname(type, _name, _id, target)}/${genFname(type, _name, _id)}`
